import React, { useState, useEffect } from 'react'
import { Select , Form , Row ,Col} from 'antd'
import axios from 'axios'
import keys from '../../../keys'


const {Option} = Select

function JobRole(props){

    const entities = {
        "ROYALMARKETING" : "Royal Marketing",
        "SEGA" : "Sega",
        "BOTH" : "Both",
        "OTHER": "Other"
    }

    const jobRoles = {
        "SALES PERSON" : "Sales Person",
        "OFFICE STAFF" : "Office Staff",
        "DRIVER" : "Driver",
        "MANAGER" : "Manager"
    }
    
   

    // const [jobRoles , setJobRoles] = useState([])
    
    // useEffect(()=>{
    //     if (jobRoles.length === 0){
    //     axios.get(`${keys.server}/user/employee-type/`)
    //     .then(
    //         (response) => {
    //             if (response.statusText === "OK"){
    //                 setJobRoles(
    //                     response.data
    //                 )
                   
    //             }
    //         }
    //     )
    //     }
    // })

    return (
            <Row type="flex" style={{padding:"0px 20px"}} gutter={5}>
                <Col span={24}>
                    <Form.Item label="Job Type">
                        <Select onChange={(value) =>  props.addIdToState(value,"employment")} style={{ width: 200 }}>
                            {
                              Object.keys(jobRoles).map(
                                    (key , index) => {
                                        return <Option key={index} value={key}>{jobRoles[key]}</Option>
                                    }
                                )
                            }
                        </Select>
                    </Form.Item>         
                </Col>
                <Col span={24}>
                    <Form.Item label="Entity">
                    <Select onChange={(value) =>  props.addIdToState(value,"employment_entity")} style={{ width: 200 }}>
                        {
                            
                            Object.keys(entities).map(
                                (key,index) => {
                                    return <Option key={index} value={key}>{entities[key]}</Option>
                                }
                            )
                        }
                    </Select>
                    </Form.Item>            
                </Col>
            
            </Row>
           
      
    )
}

export default JobRole